<script setup lang="ts">
import CheckboxField from '@/components/Fields/CheckboxField.vue'
import InputField from '@/components/Fields/InputField.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import { EStatus } from '@/types/enum/StatusEnum'
import type { TopicFilters } from '@/types/filters/TopicFilters'

type Props = {
    filters: TopicFilters
}

defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<TopicFilters>): void
}

defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="8" class="full-width" isResponsive>
        <InputField
            :label="$t('technician.ticket.filter.object')"
            :modelValue="filters.trans"
            @change="$emit('change', { trans: $event })" />

        <CheckboxField
            :label="$t('technician.ticket.filter.archived')"
            :value="filters.archived === EStatus.ENABLED"
            @click="$emit('change', { archived: $event ? EStatus.ENABLED : undefined })"
            class="responsive-width" />
    </StackLayout>
</template>
